import Grid2 from '@thirdparty-framework/mui/material/Grid';
import { Box } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import Label from './Label';
import { useEntityPermission } from '../../providers/EntityPermissionProvider';

/*
 * typeof field?.column === 'string' is used to determine if the column is a string or a number.
 * If it's a string, we don't set gridRow, otherwise we set it to field?.row
 * This is useful for cases where you need fullwidth field and define column as "1/-1".
 */

/*
input 
{
 name:
 control: (optional)
 label:{localeId, defaultMessage},
 column:
  row: 
}
*/

function FieldWrapperVertical({
  field,
  errors = [],
  customComponents = [],
  children,
  noLabels = false,
}) {
  const [urlParams] = useSearchParams();
  const showPermission = urlParams.get('permissions') || 0;

  const { isReadOnly } = useEntityPermission();

  const readOnly = isReadOnly(field?.permission, '');

  if (!field?.label?.localeId) {
    return children;
  }
  let style = {};
  if (field?.column) {
    style = {
      gridRow: typeof field?.column === 'string' ? null : field?.row,
      gridColumn: field?.column,
    };
  }

  const ToolTipComponent = customComponents?.[field?.toolTipComponent] || null;

  return (
    <Grid2 xs="grow" key={field?.name} style={style}>
      {noLabels === false && (
        <Label
          htmlFor={field?.name.replace('.', '-')}
          style={{ display: 'block', marginBottom: '5px' }}
          error={!!errors[field?.name]}
          focused={!!errors[field?.name]}
          required={field?.required && !readOnly}>
          {field?.label?.defaultMessage && (
            <FormattedMessage
              id={field?.label?.localeId}
              defaultMessage={field?.label?.defaultMessage}
            />
          )}
          {ToolTipComponent && <ToolTipComponent />}
        </Label>
      )}{' '}
      {showPermission ? field?.permission : ''}
      <Box
        style={{
          ...(field?.control === 'subsection'
            ? {
                border: '1px solid #ccc',
                borderRadius: '10px',
                padding: '8px',
              }
            : {}),
        }}>
        {children}
      </Box>
    </Grid2>
  );
}

export default FieldWrapperVertical;
